import { Injectable, Optional } from '@angular/core';
import { MiaAuthHttpService, AuthenticationService } from '@mobileia/authentication';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse, MIATableModel, ApiPagination } from '@mobileia/core';

@Injectable({
  providedIn: 'root'
})
export class BaseTableService<T> extends MiaAuthHttpService {

  basePathUrl = '';

  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService,
    //@Optional() protected basePath: string
  ) {
    super(http, authService);
    //this.basePathUrl = basePath;
  }

  fetch(itemId: number): Observable<ApiResponse<T>> {
    return this.postAuthObject(environment.baseUrl + this.basePathUrl + '/fetch', { id: itemId });
  }

  save(item: T): Observable<ApiResponse<boolean>> {
    return this.postAuthObject(environment.baseUrl + this.basePathUrl + '/save', item);
  }

  fetchList(params: MIATableModel): Observable<ApiResponse<ApiPagination<T>>> {
    return this.postAuthObject(environment.baseUrl + this.basePathUrl + '/list', params.toParams());
  }

  remove(itemId: number): Observable<ApiResponse<boolean>> {
    return this.postAuthObject(environment.baseUrl + this.basePathUrl + '/remove', { id: itemId });
  }
}
